module.exports = __webpack_public_path__ + "media/components/HowItWorks/components/WhoNooklynFor/agents-32ea3620c356bc88362e4665543cabe7.jpg";